// extracted by mini-css-extract-plugin
export default {"originPath":"_0xDuiRRtUKoLs1PGkAh"};